import api, { GetAllParams } from "@/lib/api.ts";
import { PhotosResponse } from "@/models/photo.model.ts";
import { AxiosResponse } from "axios";

export async function getPhotos(params: GetAllParams) {
  return api
    .get("photos", {
      params,
    })
    .then((response: AxiosResponse<PhotosResponse>) => response.data);
}
